import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {Layout} from "../core/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./views/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import Home from "./views/landing/pages/home/Home";
import About from "./views/landing/pages/About"
import Terms from "./views/landing/pages/Terms"
import Price from "./views/landing/pages/price/Price"
import Guide from "./views/landing/pages/guide/Guide"
import "./views/landing/sass/Index.scss"
export function RoutesProvider() {
    const {isAuthorized} = useSelector(
        ({user}) => ({
            isAuthorized: user.isLogin,
        }),
        shallowEqual
    );

    return (
        <Switch>
            <Route  path="/" exact component={Home}/>
            <Route  path="/about" exact component={About}/>
            <Route  path="/terms" exact component={Terms}/>
            <Route  path="/price" exact component={Price}/>
            <Route  path="/guide" exact component={Guide}/>

            <Route path="/error" component={ErrorsPage}/>
            {!isAuthorized && (
                <Route>
                    <AuthPage />
                </Route>
            )}
             {/* ) : (
                 <Redirect from="/auth" to="/"/>
             )} */}

            <Route path="/logout" component={Logout}/>


            {!isAuthorized ? (
                <Redirect to="/auth/login"/>
            ) : (
                <Layout>
                    <BasePage/>
                </Layout>
            )}
        </Switch>
    );
}
